export const maxMobileViewWidth = '1024px'

export const isDesktopView = () => window.matchMedia(`(min-width: ${maxMobileViewWidth})`).matches
